import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ensureFreshAppCache, registerCacheHygiene } from "@/lib/cachePurge";

function boot() {
  registerCacheHygiene();
  // A cross-origin handoff used to be claimed here, before the first render, so
  // a route guard could not bounce the admin to /login mid-hop. Ops is
  // same-origin now and the tile stores the token before navigating, so the
  // session already exists by the time anything mounts.

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  // Cache cleanup and version probing are best-effort recovery work. They may
  // reload a stale build, but must never hold the first useful render hostage
  // to a slow service-worker, Cache API, DNS, proxy, or version endpoint.
  ensureFreshAppCache().catch(() => {});
}

boot();
